import { footerNavigationQueryOptions } from '@/services/queryOptions/footerNavigationQueryOptions';
import { useSuspenseQuery } from '@tanstack/react-query';
import { CustomNavLink } from '../custom-navlink';
import { CustomNavLinkExternal } from '../custom-navlink-external';
import React, { lazy, Suspense } from 'react';
import { DownloadApp } from './download-app';
import { onClickNavExternal, onClickNavInternal } from '@/utils/navigation';
import { FOOTER_NAV_TYPE } from '@/constants/app.constants';

const AddressSearchLazy = lazy(() => import('@/components/address-search'));
const Footer = () => {
  const { data: footerData, isError } = useSuspenseQuery(
    footerNavigationQueryOptions
  );

  if (isError) {
    return null;
  }

  return (
    <footer className="container lg:pb-[63px] pb-12 md:pb-8 pt-8 md:pt-12 lg:pt-20">
      <div className="mb-[50px] lg:mb-[80px]">
        <h3 className="text-white font-nunito700 text-base md:text-lg text-center mb-4">
          Check your address for nbn eligibility
        </h3>
        <Suspense fallback={null}>
          <AddressSearchLazy isFromBanner={false} />
        </Suspense>
      </div>
      <div className="group grid gap-5 md:gap-x-[45px] lg:gap-x-[150px] xl:gap-x-[143px] grid-cols-2 md:grid-cols-[115px_90px_135px_204px] lg:grid-cols-[131px_98px_152px_316px] lg:justify-center">
        {footerData.map((item) => (
          <div
            key={item.page.id}
            className="flex flex-col grow basis-1/2 md:grow-0 md:basis-1/4 [&:nth-of-type(2)]:row-span-2 md:[&:nth-of-type(2)]:row-span-1"
          >
            <div className=" font-nunito700 text-white mb-4 text-sm lg:text-base">
              {item.page.title}
            </div>
            {item.children.map((child) => (
              <React.Fragment key={child.page.url}>
                {child.page.new_window ? (
                  <CustomNavLinkExternal
                    onClick={() =>
                      onClickNavExternal({
                        url: child.page.url,
                        title: child.page.title,
                        navType: FOOTER_NAV_TYPE,
                      })
                    }
                    href={child.page.url}
                    className="text-sm lg:text-base text-white mb-2 cursor-pointer"
                  >
                    {child.page.title}
                  </CustomNavLinkExternal>
                ) : (
                  <CustomNavLink
                    onClick={() =>
                      onClickNavInternal({
                        url: child.page.url,
                        title: child.page.title,
                        navType: FOOTER_NAV_TYPE,
                      })
                    }
                    to={child.page.url}
                    search
                    className="text-sm lg:text-base text-white mb-2 cursor-pointer"
                  >
                    {child.page.title}
                  </CustomNavLink>
                )}
              </React.Fragment>
            ))}
          </div>
        ))}
        <div className="md:flex md:flex-col md:basis-1/4 space-y-2 col-span-2 md:col-span-1 text-white mt-[28px] md:mt-0 row-span-1">
          <DownloadApp />
        </div>
      </div>
    </footer>
  );
};
export { Footer };
